module.exports = __webpack_public_path__ + "img/w6.9e7570fe.svg";